var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "col" },
        [
          _c("card-title-component", {
            attrs: { title: _vm.$t("guestlist.searchSection.title") }
          }),
          _vm._v(" "),
          _c("div", { staticClass: "card-content" })
        ],
        1
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row filter-row" }, [
      _c(
        "div",
        { staticClass: "col-lg-6" },
        [
          _c(
            "b-form-group",
            { staticClass: "mb-0" },
            [
              _c(
                "b-input-group",
                [
                  _c("b-form-input", {
                    staticClass: "o-form",
                    attrs: {
                      placeholder: _vm.$t(
                        "guestlist.searchSection.searchInputPlaceholder"
                      )
                    },
                    model: {
                      value: _vm.filter,
                      callback: function($$v) {
                        _vm.filter = $$v
                      },
                      expression: "filter"
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "b-input-group-append",
                    [
                      _c(
                        "b-btn",
                        {
                          staticClass: "o-button clear-button",
                          attrs: { disabled: !_vm.filter },
                          on: {
                            click: function($event) {
                              _vm.filter = ""
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n                            " +
                              _vm._s(
                                _vm.$t("guestlist.searchSection.clearButton")
                              ) +
                              "\n                        "
                          )
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "col" },
        [
          _c("card-title-component", {
            attrs: { title: _vm.$t("guestlist.resultSection.title") }
          }),
          _vm._v(" "),
          _c("div", { staticClass: "card-content" })
        ],
        1
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "col" },
        [
          _c(
            "b-table",
            {
              attrs: {
                id: "contacts-table",
                stacked: "lg",
                hover: "",
                small: "",
                fixed: "",
                items: _vm.localContacts,
                "per-page": _vm.perPage,
                "current-page": _vm.currentPage,
                "total-rows": _vm.totalRows,
                fields: _vm.computedFields,
                filter: _vm.filter
              },
              on: { filtered: _vm.onFiltered },
              scopedSlots: _vm._u([
                {
                  key: "actions",
                  fn: function(row) {
                    return [
                      row.item.onGuestlist
                        ? _c(
                            "a",
                            {
                              attrs: { href: "javascript:void(0)" },
                              on: {
                                click: function($event) {
                                  $event.stopPropagation()
                                  _vm.removeFromGuestlist(row.item)
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(
                                    _vm.$t(
                                      "guestlist.resultSection.table.removeFromAction"
                                    )
                                  ) +
                                  "\n                    "
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm._v(
                        "\n                    " +
                          _vm._s(row.item.on_guestlist) +
                          "\n                "
                      )
                    ]
                  }
                }
              ])
            },
            [
              _c("template", { staticClass: "o-thead", slot: "HEAD_firstname" })
            ],
            2
          )
        ],
        1
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "col" },
        [
          _c("b-pagination", {
            attrs: {
              align: "center",
              size: "sm",
              "total-rows": _vm.totalRows,
              "per-page": _vm.perPage
            },
            model: {
              value: _vm.currentPage,
              callback: function($$v) {
                _vm.currentPage = $$v
              },
              expression: "currentPage"
            }
          })
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-317a8162", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-317a8162","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/funeral/GuestlistComponent.vue
// module id = null
// module chunks = 